// extracted by mini-css-extract-plugin
export default {"container":"yQ_SjG","text":"gtZkSg","spinner":"K5FtGP"};